module.exports = __webpack_public_path__ + "img/602.47e118c3.png";